import { render, staticRenderFns } from "./NotesView.vue?vue&type=template&id=1c67770e&scoped=true"
import script from "./NotesView.vue?vue&type=script&lang=js"
export * from "./NotesView.vue?vue&type=script&lang=js"
import style0 from "./NotesView.vue?vue&type=style&index=0&id=1c67770e&prod&lang=scss&scoped=true"
import style1 from "./NotesView.vue?vue&type=style&index=1&id=1c67770e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67770e",
  null
  
)

export default component.exports